import { css } from "styled-components";
import { spacingMixin } from "../spacingMixin";
import { typographyMixin } from "../typographyMixin";
import { semanticChildrenMixin } from "../semanticChildrenMixin";
/** @class TextMixin */

/** @method */

export var TextMixin = function TextMixin(props) {
  return css(["", " margin:0;", " ", ""], typographyMixin(props), spacingMixin(props), semanticChildrenMixin(props));
};